export const REGEX = {
  EMAIL: new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{1,}$/),
  NAME: new RegExp(/^[a-zA-Z\s]+$/),
  URL: new RegExp(
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
  ),
  NUMBERS: {
    POSITIVE_INTEGER_NUMBER: new RegExp(/^[1-9]\d*$/),
    NUMBER_WITH_DOT: new RegExp(/^[0-9]{1,9}([,.][0-9]{1,2})?$/),
  },
  CURRENCY: {
    USD: new RegExp(/^(\d{1,3})(,\d{1,3})*(\.\d{1,})?$/),
  },
  PHONE: new RegExp(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/),
};

export const GLOBAL_TEXT = {
  ALERT_MESSAGES: {
    CONFIRM_LATE_NIGHT_SLOT_SELECTION_AMBASSADOR:
      "You have selected late night or early morning meeting time for ambassador. Are you sure you want to proceed?",
    CONFIRM_REJECT: "Are you sure you want to reject?",
    TIME_SLOT_CONFLICT_USER_MESSAGE:
      "The security practitioner is unavailable between {from} to {to} due to a conflicting meeting. Please suggest another time.",
  },
};

export const IMAGES_PATH = process.env.PUBLIC_URL + "/assets/imgs";
export const API_TIMEOUT = 60000;

export * from "./lists";
